export const m4l0Solution = `%lang starknet

// Fibonacci numbers are defined by the following recurrence:
// F(0) = 0
// F(1) = 1
// F(n) = F(n-1) + F(n-2)
// do not modify code on this line or above

// TODO: write a recursive implementation of fibonacci numbers that returns the nth fibonacci number
func fibonacci(n : felt) -> (result : felt) {
    alloc_locals;
    if (n == 0) {
        return (result = 0);
    }
    if (n == 1) {
        return (result = 1);
    }
    let (local n_1) = fibonacci(n - 1);
    let (local n_2) = fibonacci(n - 2);
    return (result = n_1 + n_2);
}

// do not modify code on this line or below

@external
func test_fibonacci{syscall_ptr : felt*}() {
    let (n) = fibonacci(0);
    assert n = 0;
    let (n) = fibonacci(1);
    assert n = 1;
    let (n) = fibonacci(7);
    assert n = 13;
    let (n) = fibonacci(10);
    assert n = 55;
    return ();
}`;
